import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { I18n } from 'aws-amplify';

import { ClipboardCheck } from 'react-bootstrap-icons';
import { Overlay, Tooltip } from 'react-bootstrap';

import { isNull, isUndefined } from './../../shared/utils/misc';
import { const2Msg } from './../../shared/constants/index';
import { parseAsMoment } from './../../shared/utils/date';

/**
 * ライセンス一覧の1行分
 */
export const LicenceRecord = (props) => {
  const { licence, user, index } = props;

  const [tooltips, setTooltips] = useState(false);
  const target = useRef(null);

  // ライセンスキーのコピー
  const onCopy = (licenceKey) => {
    if (!licenceKey || !navigator?.clipboard?.writeText) return;

    navigator.clipboard.writeText(licenceKey).then(
      () => {
        setTooltips(true);
        setTimeout(() => {
          setTooltips(false);
        }, 3000);
      },
      () => {
        // 失敗時は特に何もしない（必要ならログなど）
      }
    );
  };

  // ライセンス詳細ページへのリンク情報
  const goLicencePage = (argLicence) => ({
    pathname: `/licence/${argLicence.id}`,
    state: { userId: argLicence.userId },
  });

  // 拡張機能の有無（user が未定義でも落ちないように）
  const isCorp = () => {
    if (!user) return false;
    return !isUndefined(user.corp) && user.corp && !isNull(user.corp);
  };

  const renderDate = (value, format = 'YYYY年MM月DD日') => {
    if (!value) return '';
    return parseAsMoment(value).format(format);
  };

  return (
    <tr>
      {/* active バッジ */}
      <td className="text-center">
        {licence.active ? (
          <span className="badge bg-success">{I18n.get('general_active')}</span>
        ) : (
          <span className="badge bg-danger">{I18n.get('general_inactive')}</span>
        )}
      </td>

      {/* ライセンスキー + コピー */}
      <td>
        <Link to={goLicencePage(licence)}>{licence.licenceKey}</Link>{' '}
        <ClipboardCheck
          color="gray"
          size={14}
          ref={target}
          onClick={() => onCopy(licence.licenceKey)}
        />
        <Overlay target={target.current} show={tooltips} placement="right">
          <Tooltip id={`tooltip-${index}`}>コピーしました</Tooltip>
        </Overlay>
      </td>

      {/* UUID */}
      <td>{licence.uuid}</td>

      {/* 期間種別 */}
      <td>{const2Msg(licence.period)}</td>

      {/* サブスク期限 or 永久表示 */}
      {licence.subscriptionExpiryDateAt ? (
        <td>{renderDate(licence.subscriptionExpiryDateAt)}</td>
      ) : (
        <td className="text-center">
          {I18n.get('help_licence_period_perpetual')}
        </td>
      )}

      {/* 保守期限 */}
      <td>{renderDate(licence.maintenancePeriod)}</td>

      {/* ユーザ名（リンク付き） */}
      <td>
        {user ? (
          <Link to={`/user/${user.id}`}>{user.username}</Link>
        ) : (
          '(不明)'
        )}
        {/* 
        {isCorp() && (
          <>
            {' '}
            <span className="badge bg-success">
              {I18n.get('table_column_user_corp')}
            </span>
          </>
        )}
        */}
      </td>

      {/* 更新日・作成日 */}
      <td>{renderDate(licence.updatedAt, 'YYYY年MM月DD日 HH:mm')}</td>
      <td>{renderDate(licence.createdAt, 'YYYY年MM月DD日 HH:mm')}</td>
    </tr>
  );
};
